import { ThemeContext } from 'contexts/theme-context'
import * as React from 'react'

function UserIcon(props: React.SVGProps<SVGSVGElement>) {
  const { theme } = React.useContext(ThemeContext)
  return (
    <svg width={16} height={16} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6 9.333a3.333 3.333 0 00-3.334 3.333 2 2 0 002 2h6.667a2 2 0 002-2 3.333 3.333 0 00-3.334-3.333H6zM8 1.333A3.333 3.333 0 108 8a3.333 3.333 0 000-6.667z'
        fill={theme === 'dark' ? 'white' : '#636366'}
      />
    </svg>
  )
}

export default UserIcon
